import { get, post } from "./api";

export type MeQuestion = {
  id: string;
  text: string;
  type: "single_choice" | "multi_select" | "true_false" | "free_text";
  options: string[] | null;
  language: "vi" | "en" | "km";
};

export type GivenAnswer = string[] | string | null;

export type CurrentAssignment = {
  assignmentId: string;
  timeLimitMinutes: number | null;
  startedAt: number | null;
  questions: MeQuestion[];
  answers: Record<string, { given: GivenAnswer; isCorrect: boolean | null }>;
};

export function getCurrentAssignment() {
  return get<CurrentAssignment | null>("/me/assignment");
}

export function saveAnswer(questionId: string, answer: GivenAnswer) {
  return post<{ ok: true }>("/me/assignment/answers", { questionId, answer });
}

export function submitAssignment() {
  return post<{ id: string; status: string; scorePercent: number | null }>("/me/assignment/submit");
}

export type ResultQuestion = {
  questionId: string;
  text: string;
  type: MeQuestion["type"];
  options: string[] | null;
  given: GivenAnswer;
  isCorrect: boolean | null;
  correctAnswer?: string[] | null;
  explanationHtml?: string;
};

export type MemberResult = {
  status: "not_started" | "in_progress" | "submitted" | "pending_grading" | "completed";
  scorePercent: number | null;
  passed: boolean | null;
  submittedAt: number | null;
  finalizedAt: number | null;
  explanationsReleased: boolean;
  questions: ResultQuestion[];
};

export function getMyResult() {
  return get<MemberResult | null>("/me/result");
}
